// extracted by mini-css-extract-plugin
module.exports = {"links":"Links_links__3xS1r"};